// 동의서 템플릿 API
import HTTP from 'apiDefault'

// 동의서 템플릿 조회
const get = (accountID, templateID) => {
  return HTTP.get(`/agreement/${accountID}/detail/${templateID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 카테고리별 조회
const list = (accountID, categoryID) => {
  return HTTP.get(`/agreement/${accountID}/list/${categoryID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 최신/일반 조회
const listRecent = (accountID, onlyLast) => {
  return HTTP.get(`/agreement/${accountID}/list?only_last=${onlyLast}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}


// 동의서 템플릿 생성
const create = (accountID, data) => {
  return HTTP.post(`/agreement/${accountID}/create`,
    toServerData(data)
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 업데이트
const update = (accountID, data) => {
  const toServerData1 = toServerData(data)
  // id 유지
  toServerData1.id = data.id
  return HTTP.post(`/agreement/${accountID}/update`,
    toServerData1
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 복제
const copy = (accountID, templateID) => {
  return HTTP.post(`/agreement/${accountID}/copy/${templateID}`,
    { id: templateID }
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 삭제
const remove = (accountID, templateID) => {
  return HTTP.delete(`/category/${accountID}/delete/${templateID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 동의서 템플릿 카테고리 변경, form요청
const updateCategory = (accountID, templateID, data) => {
  let fd = new FormData()
  fd.set('category_id', data)
  return HTTP.post(`/agreement/${accountID}/update_category/${templateID}`, fd
    , {
      headers: {
        Authorization: window._VUE_STATE.header,
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

// 동의서 템플릿 검색
const search = (accountID, categoryID, page, pageSize, search) => {
  let fd = new FormData()
  if (categoryID) {
    fd.set('category_id', categoryID)
  }
  if (search) {
    search = search.trim()
  }
  if (search) {
    fd.set('name', search)
  }
  return HTTP.post(`/agreement/${accountID}/search?page=${page}&size=${pageSize}`, fd, {
    headers: {
      Authorization: window._VUE_STATE.header,
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 동의서 템플릿 코드 변경, form 요청
const updateCode = (accountID, templateID, code,
                    authority1,
                    authority2,
                    authority3,
                    ) => {
  let fd = new FormData()
  fd.set('code', code)
  fd.set('authority1', authority1)
  fd.set('authority2', authority2)
  fd.set('authority3', authority3)
  return HTTP.post(`/agreement/${accountID}/update_etc/${templateID}`, fd, {
      headers: {
        Authorization: window._VUE_STATE.header,
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}
const updateImage = (accountID, templateID,image,)=>{
  let fd = new FormData()
  fd.set('file', image)
  return HTTP.post(`/agreement/${accountID}/update_image/${templateID}`, fd, {
      headers: {
        Authorization: window._VUE_STATE.header,

      },
    },
  )
}
// 동의서 템플릿별 이미지 조회
const getImageList = (accountID, templateID) => {
  return HTTP.get(`/agreement/${accountID}/get_image/${templateID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

const deleteImage = (accountID, templateID,fileName) => {

  return HTTP.get(`/agreement/${accountID}/delete_image/${templateID}?fileName=${fileName}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}
const sample = {
  'agreementContents': [
    {
      'contents': 'test page 1',
      'no': 1,
    },
    {
      'contents': 'test page 2',
      'no': 2,
    },
  ],
  'agreementRequirements': [
    {
      'requirement': 1,
    },
    {
      'requirement': 2,
    },
  ],
  'name': 'api 생성 테스트',
}

const fromServerData = (data) => {
  const contents = {
    // 이름 = 카테고리 = 템플릿 이름 = 파일이름
    title: data.name,
    // 필수 항목 필드 id 목록
    requirementIDList: data.agreementRequirements,
    // 페이지, 나머지는 갱신
    pages: data.agreementContents.filter(p => p.agreementType === 'CUSTOMER'),
    // 설명 페이지
    descPages: data.agreementContents.filter(p => p.agreementType === 'DESCRIPTION'),
    // 전체 페이지
    allPages: data.agreementContents,

    groupID: data.groupId,

    // 서버와 같은 이름
    name: data.name,
    version: data.version,
    templateStatus: data.templateStatus,
    createdOn: data.createdOn,
    code: data.code,
    status: data.status,
    enabled: data.enabled,
    categoryName: data.agreementCategory.name,
    createdOnString: new Date(data.createdOn).toLocaleString(),

    authority1: data.authority1,
    authority2: data.authority2,
    authority3: data.authority3,

    timeStamp: data.timestamp,
    agreementTemplateImage : data.agreementTemplateImage,
  }

  return contents
}

const toServerData = ({
                        title, pages, selected,
                        descPages, publish, version, groupID,
                      }) => {

  const templateContents = []

  // 작성 페이지
  if (pages) {
    pages.forEach((v, i) => {
      templateContents.push({
        contents: v.contents,
        no: i + 1,
        agreementType: 'CUSTOMER',
      })
    })
  }

  // 설명 페이지
  if (descPages) {
    descPages.forEach((v, i) => {
      templateContents.push({
        contents: v,
        no: i + 1,
        agreementType: 'DESCRIPTION',
      })
    })
  }

  return {
    'agreementContents': templateContents,
    'agreementRequirements': selected ? selected : [],
    'name': title,
    'status': publish ? 'PUBLISH' : 'TEMPORARY',
    'groupId': groupID,
    'version': version,
  }
}

export {
  get,
  create,
  update,
  remove,
  fromServerData,
  toServerData,
  list,
  updateCategory,
  updateCode,
  search,
  copy,
  listRecent,
  updateImage,
  getImageList,
  deleteImage,
}



// WEBPACK FOOTER //
// ./src/api/template.js